document.addEventListener("DOMContentLoaded", () => {
  if (!window.location.pathname.includes("/products/copper-head")) return;

  function updateImages(selectedSize) {
    const normalized = selectedSize.toLowerCase().replace("ft", "").trim();
    const altMatch = `copper-head-${normalized}`;
    const productImages = document.querySelectorAll('img[alt^="copper-head-"]');
    let firstVisibleIndex = null;

    productImages.forEach((img) => {
      const galleryMedia = img.closest(".product-gallery__media");
      if (!galleryMedia) return;

      const isMatch = img.alt === altMatch;
      galleryMedia.hidden = !isMatch;
      galleryMedia.style.display = "";

      if (isMatch && firstVisibleIndex === null) {
        const carousel = galleryMedia.closest("media-carousel");
        if (carousel) {
          firstVisibleIndex = Array.from(carousel.children).indexOf(
            galleryMedia,
          );
        }
      }
    });

    const thumbnails = document.querySelectorAll(
      '.product-gallery__thumbnail img[alt^="copper-head-"]',
    );
    thumbnails.forEach((thumb) => {
      const thumbWrapper = thumb.closest(".product-gallery__thumbnail");
      if (!thumbWrapper) return;

      const isMatch = thumb.alt === altMatch;
      thumbWrapper.hidden = !isMatch;
      thumbWrapper.style.display = "";
    });

    if (firstVisibleIndex !== null) {
      document
        .querySelectorAll("product-gallery media-carousel")
        .forEach((carousel) =>
          carousel.select(firstVisibleIndex, { animate: false }),
        );
    }
  }

  const variantButtons = document.querySelectorAll(
    ".variant-picker__option-values label.block-swatch"
  );

  variantButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const selectedSize = button.textContent.trim();
      updateImages(selectedSize);
    });
  });

  const selected = document.querySelector(
    ".variant-picker__option-values label.block-swatch input:checked + span"
  );
  if (selected) {
    updateImages(selected.textContent.trim());
  }

  setTimeout(() => {
    const firstButton = document.querySelectorAll(
      ".variant-picker__option-values .block-swatch"
    )[1];
    if (firstButton) firstButton.click();
  }, 500);
});

(function () {
  // --- Solo ejecutar en https://pockethose.com/products/ballistic-hose ---
  function enPaginaCorrecta() {
    var host = location.hostname.replace(/^www\./, '');
    var path = location.pathname.replace(/\/+$/, ''); // quita barra final
    // acepta /products/ballistic-hose y variantes con prefijo de idioma (/es/products/...)
    var esRuta = /^(\/[a-z]{2}(-[a-z]{2})?)?\/products\/ballistic-hose$/i.test(path);
    return host === 'pockethose.com' && esRuta;
  }

  if (!enPaginaCorrecta()) return;
  // -----------------------------------------------------------------------

  var TARGET = 'PH-Ballistic-Red-A25-ExpandContract';
  var NEW_SRC = 'https://cdn.shopify.com/s/files/1/0626/0693/4174/files/IMG_1.jpg?v=1786634011';

  var style = document.createElement('style');
  style.textContent =
    'media-carousel.no-smooth, media-carousel.no-smooth * {' +
    '  scroll-behavior: auto !important;' +
    '}';
  document.head.appendChild(style);

  function reemplazarImagen() {
    var imgs = document.querySelectorAll('img[src*="' + TARGET + '"], img[srcset*="' + TARGET + '"]');
    var reemplazadas = false;
    imgs.forEach(function (img) {
      if (img.dataset.replaced === 'true') return;
      img.src = NEW_SRC;
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      img.dataset.replaced = 'true';
      reemplazadas = true;
    });
    return reemplazadas;
  }

  function irAImagen() {
    var gallery = document.querySelector('product-gallery');
    if (!gallery) return false;
    var carousel = gallery.querySelector('media-carousel');
    var thumbs = gallery.querySelectorAll('.product-gallery__thumbnail');
    if (!thumbs.length) return false;

    reemplazarImagen();

    var target = Array.prototype.find.call(thumbs, function (btn) {
      var img = btn.querySelector('img');
      return img && (
        img.src.indexOf(TARGET) !== -1 ||
        img.dataset.replaced === 'true'
      );
    }) || thumbs[1];
    if (!target) return false;

    if (carousel) carousel.classList.add('no-smooth');
    target.click();
    if (carousel) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          carousel.classList.remove('no-smooth');
        });
      });
    }
    return true;
  }

  function iniciar() {
    var intentos = 0;
    var timer = setInterval(function () {
      intentos++;
      if (irAImagen() || intentos > 20) clearInterval(timer);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  document.addEventListener('variant:change', function () {
    setTimeout(function () {
      reemplazarImagen();
      irAImagen();
    }, 100);
  });

  var observer = new MutationObserver(function () {
    // si el theme navega sin recargar, apagamos el observer al salir del producto
    if (!enPaginaCorrecta()) { observer.disconnect(); return; }
    reemplazarImagen();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();